const sex = ["男:男", "女:女"];
let exportObj = {
  sex,
};

/**
 * json格式的类型,转为下拉框可用的array
 * @param addAll 是否添加[全部]选项
 */
const toSelect = function(type, addAll) {
  let typeArr = [];
  if (addAll) {
    let item = {
      value: -1,
      label: "全部",
    };
    typeArr.push(item);
  }
  for (let key in type) {
    let keyInt = parseInt(key);
    let item = {
      value: keyInt,
      label: type[key],
    };
    typeArr.push(item);
  }
  return typeArr;
};

const productionLine = {
  0: " ",
  1: "控制柜产线1",
  2: "控制柜产线2",
  3: "控制柜产线3",
  4: "控制柜产线4",
  5: "控制柜产线5",
};

const inspectionPercentage = {
  10: "10",
  20: "20",
  30: "30",
  40: "40",
  50: "50",
  60: "60",
  70: "70",
  80: "80",
  90: "90",
};
const inspectionType = {
  10: "来料检验",
  20: "生产入库检验",
  30: "出货检验",
};
const itemDataType = {
  10: "值类型",
  20: "图片",
  30: "数据类型",
};
const inspectionMethod = {
  0: "全检",
  1: "免检",
  2: "抽检",
};
const inspectionStation = {};
const departmentName = {
  0: "请选择",
  1: "总经办",
};

//紧急程度
const urgencyType = {
  10: "一般",
  20: "较急",
  30: "特急",
};

//故障修理方法
const faultDealMethod = {
  10: "内修",
  20: "外修",
};
const keyEquipment = {
  0: "否",
  1: "是",
};
//维修负责人
const repairMan = {
  1: "张峰",
  2: "吴伟龙",
  3: "金鸣华",
  4: "范晓华",
};

//处理方法
const dealMethod = {
  10: "内修",
  20: "外修",
};

//修理结果
const result = {
  10: "不可使用",
  20: "可以使用",
};

//状态
const reportOrderStatus = {
  20: "待维修",
  25: "待外修",
  30: "已修复",
  40: "已确认",
};
//撤销状态
const repealStatus = {
  10: "撤销中",
  20: "拒绝撤销",
  30: "已撤销",
};
//搜索-状态
const searchReportOrderStatus = {
  20: "待维修",
  25: "待外修",
  30: "已修复",
  40: "已确认",
};
const customerTypeName = {
  0: "整梯",
  1: "工程",
};
const storageInspectionType = {
  10: "控制柜",
  20: "人机",
  30: "线缆",
};
const inspectionResult = {
  0: "NG",
  1: "OK",
};
const checkStatus = {
  0: "待检验",
  1: "已检验",
  2: "已入库",
};
const specialInspectsBindType = {
  1: "特殊工单",
  2: "变更提醒",
  3: "非标提醒",
  4: "项目检验",
};
const parentName = {
  0: "总经理",
  1: "总监",
  2: "会计",
  3: "出纳",
  4: "助理",
  5: "仓管员",
  6: "质管员",
  7: "销售员",
  8: "部门经理",
  9: "普通员工",
};
const category = {
  0: "内部用户",
  1: "外部用户",
};
const deliveryType = {
  0: "主动送货",
  1: "采购组通知",
};
const flowName = {
  0: "eMES销售订单",
  1: "sAP销售订单",
};
const status = {
  0: "启用",
  1: "禁用",
};

const gender = {
  0: "男",
  1: "女",
};
const purchaseStatus = {
  0: "待提交",
  10: "待审核",
  15: "审核中",
  18: "待初检",
  30: "初检中",
  20: "待复检",
  40: "复检中",
  45: "待入库",
  50: "已入库",
  98: "退回",
};

const reportStatus = {
  10: "初检",
  20: "复检",
  30: "完成",
};
const flowStatus = {
  0: "未提交",
  5: "被撤回/待提交",
  10: "已提交",
};

const dataType = {
  1000: "字符型",
  1001: "整数型",
  1002: "浮点型",
  1003: "日期型",
  1004: "枚举型",
  1006: "布尔型",
};
const mappingMaterialType = {
  10: "控制柜",
  20: "人机",
};
const valueType = {
  0: "单选",
  1: "多选",
};


const purchaseOrderStatus = {
  2: "正常",
  10: "暂停",
  20: "撤销",
};
const receiveStatus = {
  0: "全部",
  10: "部分到货",
  20: "已到货",
};

const isDefault = {
  0: "否",
  1: "是",
};

const BusinessApplicationStatus = {
  2201: "未提交",
  2202: "待区总审核",
  2203: "通过",
  2204: "退回",
  2205: "作废",
  2206: "待营销中心审核",
  2207: "待财务审核",
  2208: "待销售总监审核",
  2209: "待财务总监审核",
  2210: "待总经理审核",
  2220: "待产品确认",
  2230: "待成本核算",
};

const createTypes = {
  0: "SAP导入",
  10: "手工创建",
};
const salesCountrys = {
  0: "不限",
  10: "国内",
  20: "海外",
};

const groupType = {
  10: "键值对类型",
  20: "表格类型",
};
const paramValueType = {
  10: "字符类型",
  20: "枚举类型",
};

const electronicStatus = {
  10: "未上传",
  20: "上传成功",
  21: "上传失败",
};

const fileType = {
  10: "PDF",
  20: "EXCEL",
};

const upLoadNode = {
  10: "销售订单",
  20: "发货单",
};

const printType = {
  10: "墨打",
  20: "针打",
};

const maintenanceType = {
  1: "节假日",
  2: "周末工作日",
};

const cycleNum = {
  1: "每日",
  7: "每周",
  30: "每月",
};

const applyType = {
  10: "客户",
  20: "厂内",
};

const specialApplicationType = {
  1: "来料",
  2: "过程",
  3: "出货",
  4: "其他",
};
const defectResult = {
  1: "成本",
  2: "发运",
  3: "性能",
  4: "其他",
};

const approveResult = {
  10: "处理中",
  20: "同意",
  30: "拒绝",
};

const puiStatus = {
  0: "待提交",
  10: "已提交",
};

const inspectionTypes = {
  210: "蒂森有机房",
  220: "蒂森无机房",
  230: "奥的斯备库",
};

const deliveryStatus = {
  10: "未回复",
  20: "已回复",
};

const customerGroup = {
  10: "一般客户",
  20: "大客户",
  30: "战略客户",
};

const salesStatus = {
  2101: "订单初稿",
  2102: "订单已提交",
  2103: "订单已报价",
  2104: "合同已评审",
  2105: "图纸料单已出",
  2106: "预付款已付",
  2107: "已排产",
  2108: "结束",
  2109: "模板",
  2110: "SAP合同已建",
  2111: "SAP订单已建",
  2112: "交期已确认",
  2113: "订单已生产",
  2114: "订单已发货",
  2115: "区域经理通过",
  2116: "区域总经理通过",
  2117: "技术支持通过",
  2118: "副总经理通过",
  2119: "作废",
  2120: "退单",
};

const liftType = {
  0: "Homelift Small cabinet",
  1: "Homelift New cabinet",
  2: "Homelift Door frame type",
  3: "Passenger - Atlas Basic",
  4: "Atlas Basic Door Frame type",
  5: "Passenger-Atlas Basic C7000 MR",
  6: "Passenger-Atlas Basic C7000 MRL",
  7: "Passenger-EN81.20 Controller",
};

const checkTypes = {
  0: "日",
  1: "周",
  2: "月",
};
const handleType = {
  10: "返工",
  20: "申请特批",
};

const checkResults = {
  0: "√(良好)",
  1: "○(有问题不影响工作)",
  2: "×(影响工作)",
};

const CREDIT_GROUP = {
  1: "大客户",
  2: "小/中等客户",
  3: "关联客户",
};

const systemIds = {
  10: "内部",
  20: "外部",
};

const proposalTypes = {
  0: "安全",
  1: "质量",
  2: "交期",
  3: "成本",
  4: "5S",
  5: "管理",
};

const configTypes = {
  10: "默认",
  20: "辅助",
  30: "H5页面",
  40: "文件",
};

const purchaseType = {
  10: "标准采购",
  20: "叫料模式",
};
const stage = {
  1: "工厂生产阶段",
  2: "工地安装阶段",
  3: "工地使用阶段",
};
const complaintNature = {
  1: "错件",
  2: "漏件",
  3: "故障",
};
const complaintGrade = {
  1: "I级 1<=数量<=9 金额(0-500)",
  2: "II级 10<=数量<=99 金额【500-5000)",
  3: "III级 100<=数量<=499 金额【5000-20000)",
  4: "IV级 数量>=500 金额>=20000 涉及安全",
};
const productType = {
  1: "AS380系列控制柜",
  2: "C7000系列控制柜",
  3: "G9000系列控制柜",
  4: "B8000系列控制柜",
  5: "轿顶盒",
  6: "COP",
  7: "LOP",
  8: "线缆",
  9: "门机",
  10: "变频器",
  11: "其他部件",
};
const errorClassification = {
  1: "订单处理问题",
  2: "安装问题",
  3: "人为接线错误",
  4: "设计问题",
  5: "图纸问题",
  6: "安装问题",
  7: "软件设计问题",
  8: "硬件设计问题",
  9: "物料发错",
  10: "其他",
};
const specialApplicationCause = {
  1: "更换/追加物品价值>5000元",
  2: "维修费用减免",
  3: "现场售后服务费用减免",
  4: "批量性质量问题",
  5: "需海外售后协助",
  6: "用车申请(客户货物运回)",
  7: "非我司原因商务申请",
};
const dealType = {
  10: "拆解",
  20: "利用",
};

const programStatus = {
  1: "未启动",
  2: "进行中",
  3: "已完成",
  4: "挂起",
};
const fileCategoryType = {
  0: "PCB规格书",
  1: "坐标文件",
  2: "GERBER",
  3: "结构件图纸",
  4: "订单资料",
};

const taskStatus = {
  1: "未启动",
  2: "开发中",
  3: "已完成",
};

//------------------------------以下部分请勿改动------------------------------

//转化为object和options
for (let key in exportObj) {
  let value = exportObj[key];
  if (Array.isArray(value)) {
    let options = [];
    let object = {};
    value.forEach((item) => {
      let itemArr = item.split(":");
      let option = {
        value: itemArr[0],
        label: itemArr[1],
      };
      object[option.value] = option.label;
      options.push(option);
    });
    value.$options = options;
    value.$object = object;
  }
}

export default {
  exportObj,
  toSelect,
  productionLine,
  inspectionPercentage,
  inspectionStation,
  inspectionType,
  itemDataType,
  inspectionMethod,
  parentName,
  departmentName,
  category,
  deliveryType,
  flowName,
  customerTypeName,
  status,
  purchaseStatus,
  gender,
  receiveStatus,
  urgencyType,
  faultDealMethod,
  dealMethod,
  result,
  reportOrderStatus,
  repealStatus,
  purchaseOrderStatus,
  repairMan,
  searchReportOrderStatus,
  BusinessApplicationStatus,
  isDefault,
  createTypes,
  fileCategoryType,
  salesCountrys,
  reportStatus,
  flowStatus,
  electronicStatus,
  dataType,
  mappingMaterialType,
  groupType,
  paramValueType,
  fileType,
  upLoadNode,
  printType,
  maintenanceType,
  cycleNum,
  keyEquipment,
  applyType,
  puiStatus,
  approveResult,
  inspectionTypes,
  deliveryStatus,
  customerGroup,
  salesStatus,
  checkTypes,
  handleType,
  checkResults,
  liftType,
  CREDIT_GROUP,
  systemIds,
  proposalTypes,
  configTypes,
  storageInspectionType,
  inspectionResult,
  checkStatus,
  specialInspectsBindType,
  purchaseType,
  stage,
  complaintNature,
  productType,
  complaintGrade,
  errorClassification,
  specialApplicationType,
  defectResult,
  programStatus,
  taskStatus,
  specialApplicationCause,
  dealType,
  valueType,
};
